module.exports = __webpack_public_path__ + "img/hazardEquip55.b3ed240d.jpg";